/** Add-menu values that open the tenant drive picker (parity with composer handlers). */
export const ADD_FROM_DRIVE_MENU_VALUES = ['drive', 'addFromDrive'];

/** Defaults for document search popover in {@link ChatInput} (was inline in BasicChatPanel). */
export const CHAT_DOCUMENT_SEARCH_DEFAULT_PROPS = Object.freeze({
  searchPlaceholder: 'Search documents...',
  height: '500px',
  maxHeight: '500px',
  width: '445px',
});
